var _excluded = ["avatarProps", "avatarSrc", "feedbackText", "jobInfos", "linkProps", "studentInfos", "title", "titleTag"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { elementType, string, arrayOf, shape } from "prop-types";
import { Text } from "#library/components/Text/Text";
import { Avatar } from "#library/components/Image/Avatar";
import { BOX_SIZES } from "#library/components/Image/Image";
import defaultAvatar from "#library/assets/images/default_avatar.svg";
import { Card } from "#library/components/Card";
import { CardFeedback } from "./CardFeedback/CardFeedback";
export var InsightCard = function InsightCard(props) {
  var _props$avatarProps = props.avatarProps,
    avatarProps = _props$avatarProps === void 0 ? {} : _props$avatarProps,
    _props$avatarSrc = props.avatarSrc,
    avatarSrc = _props$avatarSrc === void 0 ? "" : _props$avatarSrc,
    _props$feedbackText = props.feedbackText,
    feedbackText = _props$feedbackText === void 0 ? null : _props$feedbackText,
    jobInfos = props.jobInfos,
    linkProps = props.linkProps,
    studentInfos = props.studentInfos,
    title = props.title,
    _props$titleTag = props.titleTag,
    titleTag = _props$titleTag === void 0 ? "p" : _props$titleTag,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Card, restProps, /*#__PURE__*/React.createElement(Card.Aside, null, /*#__PURE__*/React.createElement(Avatar, _extends({
    src: avatarSrc
  }, avatarProps, {
    onLoadErrorPath: defaultAvatar,
    alt: "",
    boxSize: BOX_SIZES.MEDIUM
  }))), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Card.Title, {
    resetSpacing: true,
    as: titleTag,
    linkProps: linkProps
  }, title), /*#__PURE__*/React.createElement(Card.Listing, {
    removeSpacing: true
  }, jobInfos.map(function (item) {
    return /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      key: item
    }, item);
  })), /*#__PURE__*/React.createElement(Card.Listing, {
    removeSpacing: true
  }, studentInfos.map(function (item) {
    return /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      key: item
    }, item);
  })), feedbackText && /*#__PURE__*/React.createElement(CardFeedback, null, feedbackText)));
};
InsightCard.propTypes = {
  title: string.isRequired,
  titleTag: elementType,
  avatarSrc: string,
  avatarProps: shape({
    component: elementType
  }),
  jobInfos: arrayOf(string).isRequired,
  studentInfos: arrayOf(string).isRequired,
  feedbackText: string,
  linkProps: shape({}).isRequired
};